export const AI_WORKFLOW_STATUSES = {
	UNINITIALISED: 'uninitialised',
	GENERATING: 'generating',
	ERROR: 'error',
	SUCCESS: 'success',
};

export const AI_WORKFLOW_TYPES = {
	riskInfoNBEmail: 'Submission Email',
	riskInfoRenewalEmail: 'Detailed Pre-Renewal Email',
	preRenewalBasic: 'Basic Pre-Renewal Email',
	quoteRecommendationEmail: 'Quote Email',
	renewalTermsEmail: 'Renewal Terms Email',
};

export const AI_WORKFLOW_DEPENDENCIES = {
	quoteRecommendationEmail: ['riskInfoSummary', 'quoteSummary'],
	renewalTermsEmail: ['riskInfoSummary', 'quoteSummary'],
	riskInfoNBEmail: ['riskInfoSummary'],
	riskInfoRenewalEmail: ['riskInfoSummary'],
	preRenewalBasic: ['riskInfoSummary'],
};

export const AI_EMAIL_WORKFLOW_TYPES = {
	riskInfoNBEmail: 'riskInfoNBEmail',
	preRenewalBasic: 'preRenewalBasic',
	riskInfoRenewalEmail: 'riskInfoRenewalEmail',
	renewalTermsEmail: 'renewalTermsEmail',
	quoteRecommendationEmail: 'quoteRecommendationEmail',
};

export const AI_WORKFLOWS_COLLECTION = 'aiWorkflows';

// Matches the message.size() limit on aiMessages in backend/firestore.rules.config.js
export const MAX_AI_MESSAGE_LENGTH = 200000;
